import { render, staticRenderFns } from "./NewsletterTwo.vue?vue&type=template&id=6f177df8&"
import script from "./NewsletterTwo.vue?vue&type=script&lang=js&"
export * from "./NewsletterTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports